import React from 'react'
import LinearProgress from '@mui/material/LinearProgress';

const PageLoader = () => {
    return (
        <div className="fixed top-0 left-0 right-0 z-50 w-full bg-white">
            <LinearProgress />
        </div>
    );
}

export default PageLoader